/**
 * @file Manages the merchant storage in local storage
 */

export type Merchant = {
  merchantId: string;
};

/**
 * Get the current Merchant
 */
export function get(): Merchant | null {
  const merchant = window.localStorage.getItem('merchant');

  if (merchant) {
    return JSON.parse(merchant);
  }

  return null;
}

/**
 * Set the Merchant
 *
 * @param merchant
 */
export function set(merchant: Merchant) {
  window.localStorage.setItem('merchant', JSON.stringify(merchant));
}

/**
 * Remove the merchant
 */
export function remove() {
  window.localStorage.removeItem('merchant');
}
